export default __webpack_public_path__ + "static/media/step2-1.9e9463f6.svg";